import * as React from 'react';
export const IcKidney = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.68 5.66a2.997 2.997 0 00-5.36 2.68c.1.2.17.42.24.66h-.55c-1.2 0-2.27.54-3 1.38-.73-.84-1.8-1.38-3-1.38h-.55c.06-.24.14-.46.24-.66a2.997 2.997 0 00-5.36-2.68c-1.43 2.85-1.43 6.83 0 9.68A3.004 3.004 0 006.03 17c.45 0 .91-.1 1.34-.32a2.997 2.997 0 001.34-4.02c-.23-.45-.36-1.04-.41-1.66h.73c1.1 0 2 .9 2 2v7c0 .55.45 1 1 1s1-.45 1-1v-7c0-1.1.9-2 2-2h.73c-.05.62-.18 1.21-.41 1.66a2.997 2.997 0 001.34 4.02c.43.22.89.32 1.34.32 1.1 0 2.16-.61 2.69-1.66 1.43-2.85 1.43-6.83 0-9.68h-.04z'
      fill='currentColor'
    />
  </svg>
);
